import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setMeta } from '../utils/seo';

function InstallGuide() {
  useEffect(() => {
    setMeta({
      title: 'HHpoker安装教程｜iOS证书信任与安卓安装步骤',
      description:
        '汇总HHpoker安装全流程：iOS证书信任、安卓安装授权、常见报错处理与更新方法，适合首次安装与版本升级用户。',
      keywords:
        'HHpoker安装教程, HHpoker证书信任, HHpoker iOS安装, HHpoker安卓安装, HHpoker安装失败怎么办',
      url: window.location.origin + '/install-guide/',
      robots: 'index,follow',
      image: window.location.origin + '/images/banner.jpg',
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "hhpoker安装教程先看哪一步？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "先确认设备系统，再按 iOS 证书信任或 Android 权限授权流程操作。"
            }
          },
          {
            "@type": "Question",
            "name": "iOS 提示“未受信任企业级开发者”怎么处理？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "进入系统设置完成证书信任后，再返回应用重新打开。"
            }
          },
          {
            "@type": "Question",
            "name": "安卓提示“禁止安装未知应用”怎么办？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "在系统中为浏览器或文件管理器开启安装权限后重试。"
            }
          },
          {
            "@type": "Question",
            "name": "安装后闪退如何排查？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "建议按“卸载旧版-清理缓存-重装最新版-重启设备”顺序处理。"
            }
          },
          {
            "@type": "Question",
            "name": "安装流程需要多久？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "正常情况下几分钟可完成；若遇系统拦截，按教程补齐设置即可。"
            }
          }
        ]
      }
    });
  }, []);

  return (
    <div style={{ background: '#1a1c29', color: '#fff', minHeight: '100vh' }}>
      <section
        style={{
          padding: '90px 20px 40px',
          maxWidth: '920px',
          margin: '0 auto',
          lineHeight: 1.8
        }}
      >
        <h1 style={{ fontSize: '2rem', color: '#efa765', marginBottom: '12px' }}>
          HHpoker苹果iOS信任证书教程与安卓安装指引
        </h1>
        <p style={{ color: '#c8c8c8', marginBottom: '22px' }}>
          本页提供 HHpoker 最新下载后的安装流程。若你在 iPhone 出现“未受信任企业级开发者”或安卓提示“禁止安装未知应用”，可按下方步骤处理。
        </p>

        <h2 style={{ color: '#fff', marginTop: '20px' }}>一、iOS 信任证书安装步骤</h2>
        <ol style={{ paddingLeft: '22px' }}>
          <li>前往下载页获取 iOS 安装链接并完成描述文件安装。</li>
          <li>打开 iPhone 设置，进入“通用”。</li>
          <li>点击“VPN与设备管理”（部分系统显示为“描述文件与设备管理”）。</li>
          <li>找到对应企业证书，点击“信任”并二次确认。</li>
          <li>返回桌面重新打开应用，检查是否可正常启动。</li>
        </ol>

        <h2 style={{ color: '#fff', marginTop: '20px' }}>二、安卓安装指引</h2>
        <ol style={{ paddingLeft: '22px' }}>
          <li>从 HHpoker 官方下载页获取最新版 APK 安装包。</li>
          <li>首次安装时，允许浏览器或文件管理器“安装未知应用”。</li>
          <li>安装完成后建议关闭“未知来源安装”权限，提升设备安全。</li>
          <li>打开应用后如遇闪退，先清理旧版本再重装最新版。</li>
        </ol>

        <h2 style={{ color: '#fff', marginTop: '20px' }}>三、常见问题排查</h2>
        <ul style={{ paddingLeft: '22px' }}>
          <li>iOS 证书灰色不可点：请检查系统时间与网络后重试。</li>
          <li>安卓安装包解析失败：通常是包体损坏或系统版本过低，重新下载最新版。</li>
          <li>安装后无法打开：删除旧版本缓存并重启设备再安装。</li>
        </ul>

        <h2 style={{ color: '#fff', marginTop: '20px' }}>四、安装教程与失败排查FAQ</h2>
        <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：hhpoker安装教程先看哪一步？</strong></p>
        <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：先确认设备系统，再按 iOS 证书信任或 Android 权限授权流程操作。</p>
        <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：iOS 提示“未受信任企业级开发者”怎么处理？</strong></p>
        <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：进入系统设置完成证书信任后，再返回应用重新打开。</p>
        <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：安卓提示“禁止安装未知应用”怎么办？</strong></p>
        <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：在系统中为浏览器或文件管理器开启安装权限后重试。</p>
        <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：安装后闪退如何排查？</strong></p>
        <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：建议按“卸载旧版-清理缓存-重装最新版-重启设备”顺序处理。</p>
        <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：安装流程需要多久？</strong></p>
        <p style={{ color: '#aeb4c2', marginBottom: '0' }}>A：正常情况下几分钟可完成；若遇系统拦截，按教程补齐设置即可。</p>

        <div style={{ marginTop: '26px', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <Link
            to="/download"
            style={{
              background: '#efa765',
              color: '#1a1c29',
              padding: '10px 18px',
              borderRadius: '24px',
              textDecoration: 'none',
              fontWeight: 700
            }}
          >
            前往 HHpoker 最新下载
          </Link>
          <Link
            to="/clubs"
            style={{
              border: '1px solid #efa765',
              color: '#efa765',
              padding: '10px 18px',
              borderRadius: '24px',
              textDecoration: 'none'
            }}
          >
            查看 HHpoker 俱乐部ID推荐
          </Link>
        </div>
      </section>
    </div>
  );
}

export default InstallGuide;
